"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _component = _interopRequireDefault(require("./component"));

var Factory =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Factory, _Component);

  function Factory() {
    (0, _classCallCheck2.default)(this, Factory);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Factory).apply(this, arguments));
  }

  (0, _createClass2.default)(Factory, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(Factory.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'product',
            component: 'Field',
            required: true
          }, {
            name: 'properties',
            component: 'Field'
          }]
        }
      });
    }
  }, {
    key: "produce",
    value: function produce() {
      var component = this.get('product')();
      var properties = this.get('properties');

      if (properties) {
        component.set(properties);
      }

      return component;
    }
  }]);
  return Factory;
}(_component.default);

exports.default = Factory;